import { render } from "./clinic-patient-registration.vue?vue&type=template&id=7b235ac0&scoped=true"
import script from "./clinic-patient-registration.vue?vue&type=script&lang=js"
export * from "./clinic-patient-registration.vue?vue&type=script&lang=js"

import "./clinic-patient-registration.vue?vue&type=style&index=0&id=7b235ac0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b235ac0"]])

export default __exports__